import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { SidebarLayout } from '../components/layout';
import { WorkflowWizard } from '../components/workflow-wizard';
import { useAuth } from '../hooks/use-auth';

export function WorkflowWizardPage() {
  const { divisionId } = useParams<{ divisionId: string }>();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <SidebarLayout>
        <div className="flex items-center justify-center h-full">
          <div className="text-lg text-red-600 dark:text-red-400">Please log in to create workflows.</div>
        </div>
      </SidebarLayout>
    );
  }

  if (!divisionId) {
    return (
      <SidebarLayout>
        <div className="flex items-center justify-center h-full">
          <div className="text-lg text-red-600 dark:text-red-400">Division ID is required</div>
        </div>
      </SidebarLayout>
    );
  }

  return (
    <SidebarLayout>
      <WorkflowWizard
        divisionId={divisionId}
        isOpen={true}
        onClose={() => navigate(`/workflows/${divisionId}`)}
        onSuccess={(workflowId) => {
          navigate(`/workflows/${divisionId}/${workflowId}/edit`);
        }}
      />
    </SidebarLayout>
  );
}
